export const SaleNote = {
    REASON_CANCELLATION: {
        getProps: () => [
            { id: 'Demora de Despacho', text: 'Demora de Despacho' },
            { id: 'Cliente Desiste de Compra', text: 'Cliente Desiste de Compra' },
            { id: 'Producto Equivocado', text: 'Producto Equivocado' },
            { id: 'Producto Defectuoso', text: 'Producto Defectuoso' },
            { id: 'Producto Incompleto', text: 'Producto Incompleto' },
            { id: 'Producto sin stock', text: 'Producto sin stock' },
            { id: 'Retiro cancelado por vigencia', text: 'Retiro cancelado por vigencia' }
        ]
    },
    REASON_RESCHEDULED: {
      getProps: () => [
        { id: 'Eventos en Zona', text: 'Eventos en Zona' },
        { id: 'Falta Capacidad del proveedor', text: 'Falta Capacidad del proveedor' },
        { id: 'Saturación en tienda', text: 'Saturación en tienda' },
        { id: 'Demora en almacén', text: 'Demora en almacén' },
        { id: 'Cliente', text: 'Cliente' },
        { id: 'Error en sistema', text: 'Error en sistema' },
        { id: 'Demora en pago', text: 'Demora en pago' },
        { id: 'Otros', text: 'Otros' }
      ]
    }
};
